/* Author: Vaishnavi
Date: 19/11/2019
Issue NO:-
Description: fetch url issue commented
*/
import { get_axios_instance, api_variables, errorHandler, get_axios_file_instance } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_IMPORT_UDF);
var axios_instance_upload_template = get_axios_instance(api_variables.SERVICE_IMPORT_UDF_UPLOAD_TEMPLATE);
var axios_instance_download_template = get_axios_file_instance(api_variables.SERVICE_DOWNLOAD_IMPORT_UDF_TEMPLATE);

const _pk_name = "id";

const state = {
    data: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {},
    udfId: {}
};

const getters = {
    getUdf: (state) => {
        if (state.data) {
            return state.data
        } else {
            this.fetchAll()
        }
    },
    editMode: (state) => {
        return state.editMode
    },
    record: (state) => {
        return state.record
    },
    getUdfId: (state) => {
        return state.udfId
    }
}

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    addUdf: (state, payload) => {
        state.data = payload;
        state.udfId = payload.payload.data.id
    },

    updateUdfById: (state, payload) => {
        for (let i = 0; i < state.data.data.length; i++) {
            if (state.data.data[i][_pk_name] === payload.id) {
                state.data.splice(i, 1, payload);
            }
        }
    },

    removeUdfById: (state, payload) => {
        for (let i = 0; i < state.data.data.length; i++) {
            if (state.data.data.id == payload) {
                state.data.data.splice(i, 1);
            }
        }
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },

    setEditMode: (state, payload) => {
        state.editMode = payload.editMode;
        state.record = payload.record;
    }
}

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(``, { params: { le_id: payload } });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("set", res.data.payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async uploadTemplate({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance_upload_template.post(``, payload);
            commit("setFetching", false);
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post("/", payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("addUdf", res.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put(`/`, {
                udfid: payload
            });
            commit("setSaving", false);
            if (res.status == 200) {

                commit("updateUdfById", res.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async delete({ commit }, payload) {
        try {
            commit("setDeleting", true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit("setDeleting", false);
            if (res.status == 200) {
                commit("removeUdfById", payload.id);
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async changeEditMode({ commit }, payload) {
        try {
            commit("setEditMode", payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async downloadTemplate({commit},payload) {
        try {
          let res = await axios_instance_download_template.get(``, {
            params: payload
          });
          if (res.data.status) {
            const link = document.createElement("a");
            link.href = res.data.payload;
            link.setAttribute("download", "Import_UDF_Template"+ ".xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
        }
        } catch (err) {
            throw errorHandler(error);
        }
      },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}